
    import * as React from 'react';

    const Share24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Share_24_svg__Icons/Share/24" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M6,13 L6,21 L18,21 L18,13 L19,13 L19,22 L5,22 L5,13 L6,13 Z M12.5710678,3.91421356 L12.5710678,16.5710678 L11.5710678,16.5710678 L11.5710678,3.91421356 L5.70710678,9.77817459 L5,9.07106781 L12.0710678,2 L19.1421356,9.07106781 L18.4350288,9.77817459 L12.5710678,3.91421356 Z" id="Share_24_svg__Combined-Shape" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Share24.displayName = 'Share24';

    export default Share24;
  